import script from "./chartGptGloble.vue?vue&type=script&lang=js"
export * from "./chartGptGloble.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__